import { render, staticRenderFns } from "./announceType.vue?vue&type=template&id=96fc193a&"
import script from "./announceType.vue?vue&type=script&lang=js&"
export * from "./announceType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96fc193a')) {
      api.createRecord('96fc193a', component.options)
    } else {
      api.reload('96fc193a', component.options)
    }
    module.hot.accept("./announceType.vue?vue&type=template&id=96fc193a&", function () {
      api.rerender('96fc193a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/announceType.vue"
export default component.exports